/* eslint-disable */
import React from 'react';
import { Box, Button, Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import iconDocument from '../../Images/icon_document.svg';

const AttestationImpayeModal = ({ open, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth={false}
     sx={{
    '& .MuiDialog-container': {
      alignItems: 'flex-start',   // 'center' | 'flex-end' | 'flex-start'
      justifyContent: 'center',   // 'center' | 'flex-start' | 'flex-end'
      pt: '60px',                // ← distance from top of the screen
    },
  }}
    slotProps={{
      backdrop: { sx: { backgroundColor: 'rgba(0, 37, 59, 0.28)' } },
      paper: {
        sx: {
          width: '534px',
          borderRadius: '16px',
          overflow: 'hidden',
          boxShadow: '0px 12px 40px rgba(0,0,0,0.18)',
           
        },
      },
    }}
  >
    <Box sx={{
      backgroundColor: '#FFFFFF',
      height: '745px',
      width: '550px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      px: '10px',
      py: '10px',
     
    
    }}>
      {/* Grey document box */}
      <Box sx={{
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(131, 151, 174, 0.21)',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}>
        {/* Télécharger button — top-left */}
        <Box sx={{ position: 'absolute', top: '12px', left: '12px' }}>
          <Button
            startIcon={<FileDownloadOutlinedIcon sx={{ fontSize: 15 }} />}
            sx={{
              height: '34px',
              px: '14px',
              borderRadius: '8px',
              backgroundColor: '#FFFFFF',
              color: '#385576',
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '13px',
              boxShadow: '0px 2px 6px rgba(0,0,0,0.08)',
              border: '1px solid #DEE5EE',
              '&:hover': { backgroundColor: '#F8FAFC', boxShadow: '0px 2px 8px rgba(0,0,0,0.12)' },
            }}
          >
            Télécharger
          </Button>
        </Box>

        {/* Close button — top-right */}
        <Box sx={{ position: 'absolute', top: '8px', right: '8px' }}>
          <IconButton
            size="small"
            onClick={onClose}
            sx={{
              color: '#B0BCC9',
              width: 28,
              height: 28,
              '&:hover': { color: '#385576', backgroundColor: 'rgba(255,255,255,0.6)' },
            }}
          >
            <CloseIcon sx={{ fontSize: 22 }} />
          </IconButton>
        </Box>

        <img
          src={iconDocument}
          alt="document"
          style={{
            width: 60,
            height: 60,
            objectFit: 'contain',
            filter: 'brightness(0) saturate(100%) invert(58%) sepia(13%) saturate(547%) hue-rotate(178deg) brightness(95%) contrast(85%)',
            opacity: 0.5,
          }}
        />
      </Box>
    </Box>
  </Dialog>
);

export default AttestationImpayeModal;